module.exports = __webpack_public_path__ + "static/media/product-3-front.85a796d4.jpg";